import { RECRUITERCANDIDATEMATCHINGJOBS } from "../../ENVIRONMENT";

// api for recruiter matching pagination
async function recmatchingPagination(token, currentPage) {
  const response = await fetch(
    RECRUITERCANDIDATEMATCHINGJOBS + `?limit=6&page=${currentPage}`,
    {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${
          token ? token : sessionStorage.getItem("token")
        }`,
      },
    }
  );
  return response;
}
// api for recruiter matchingcard pagination
async function recmatchingCardPagination(token, card, currentPage) {
  const response = await fetch(
    RECRUITERCANDIDATEMATCHINGJOBS +
      `?card=${card}&limit=6&page=${currentPage}`,
    {
      headers: {
        "Content-Type": "Application/json",
        Authorization: `Bearer ${
          token ? token : sessionStorage.getItem("token")
        }`,
      },
    }
  );
  return response;
}

export { recmatchingPagination, recmatchingCardPagination };
